<div class="container-fluid">

    <div class="row p-4 justify-content-center">
        <div class="col">
            <h4 class="font-weight-bold text-center">
                Edit {{ data.name }}
                <div class="text-muted text-uppercase">
                    SKU {{ data.barcode }}
                </div>
            </h4>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-md-6 font-weight-bold patient-credit-amount">
            Amount:
        </div>
        <div class="col-md-6 font-weight-bold">
            <input class="form-control" [name]="data.barcode" [(ngModel)]="updatedQuantity" [attr.inputmode]="getInputMode"/>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-sm-6">
            <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">Cancel</button>
        </div>
        <div class="col-sm-6">
            <button type="button" class="btn btn-outline-primary btn-block" (click)="confirm()">Confirm</button>
        </div>
    </div>
    <div class="row" *ngIf="error">
        <div class="col">
            <div class="alert alert-danger alert-dismissible fade show">{{alertMessage}}
                <button type="button" class="close" (click)="closeAlert()" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="enableCustomKeyboard" class="keyboard-container">
        <app-custom-keyboard #customKeyboard [template]="keyboardTemplate" [setValue]="keyboardValue"
            (typedValue)="customKeyboardInput($event)"></app-custom-keyboard>
    </div>
</div>
